import { nanoid } from "@scalar-org/entities/utility";
import { withDataAttrFallback } from "../../helpers/attributes-with-data-fallback.js";
import { buildChildAttributes } from "../../helpers/build-child-attributes.js";
import { html } from "../../helpers/html-template.js";
import { validate } from "../../helpers/validate.js";
import { EditorClasses } from "../../styles.js";
import {
  attributesTabsSchema
} from "./attributes.js";
const scalarTab = {
  name: "scalar-tab",
  tagName: "scalar-tab",
  tiptapName: "custom_container",
  attributeTransform: (_, _attrs) => {
    const attrs = withDataAttrFallback(_attrs);
    return {
      id: String(attrs.id ?? nanoid()),
      title: String(attrs.title || "")
    };
  },
  render: async (_) => {
    return html`
<div
  class="custom-container-content">
    <ssg-children></ssg-children>
</div>
    `;
  }
};
const scalarTabs = {
  name: "scalar-tabs",
  tagName: "scalar-tabs",
  tiptapName: "custom_tabs",
  attributeTransform: (_content, _props, node) => {
    const props = withDataAttrFallback(_props);
    const children = buildChildAttributes({
      node,
      filterTagName: scalarTab.tagName
    });
    const transformed = {
      children,
      default: props.default || props.dataDefault,
      isMdx: props.isMdx
    };
    return validate(attributesTabsSchema, transformed);
  },
  render: async (props) => {
    const { default: defaultTab, children } = props;
    const defaultTabIndex = Math.max(
      children.findIndex(
        (child) => child.title.toLowerCase() === defaultTab?.toLowerCase()
      ),
      0
    );
    const uid = nanoid();
    const tabGroupName = `custom-tabs-input-${uid}`;
    const checkedKey = props.isMdx ? 'defaultChecked="true"' : "checked";
    const inputs = children.map((child, index) => {
      return html`
        <input
          id="${child.id}"
          class="custom-tabs-input sr-only"
          name="${tabGroupName}"
          ${index === defaultTabIndex ? checkedKey : ""}
          type="radio"
          value="${index}" />
      `;
    }).join("");
    const labels = children.map((child) => {
      return html`
        <label class="custom-tabs-tab" for="${child.id}">${child.title}</label>
      `;
    }).join("");
    const classNames = [EditorClasses.Tabs, "custom-tabs-container"];
    return html`
<div class="${classNames.join(" ")}">
  ${inputs}
  <div
    class="custom-tabs-navbar">
    <nav class="custom-tabs-nav">${labels}</nav>
  </div>
  <div class="custom-tabs-content"><ssg-children></ssg-children></div>
</div>
`;
  }
};
export {
  scalarTab,
  scalarTabs
};
//# sourceMappingURL=index.js.map
